import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import mixpanel from 'mixpanel-browser';

import { Participant } from '../types'

import PlayerField from './playerField'

import { Button, Icon, Divider, Transition } from 'semantic-ui-react'

import { GenerateTournament, GetTotalGroupStageMatches, StandardMatchesPrHeat } from '../utils/TourGenerator'
import GroupStageMatchesDropdown from './groupStageMatchCountDropdown'
import TimeEstimator from './timeEstimator'
import { useMeleeContext } from 'draft/context/MeleeContextProvider'
import { DefaultDraftOptions, DraftOptions } from 'draft/types'
import OptionsModal from 'draft/modals/optionsModal'

const MINIMUM_PLAYER_SIZE = 4;

const newPlayer = (number: number): Participant => {
    return {
        Number: number,
        Name: '',
        Wins: 0,
        StockDifference: 0,
        GamesPlayed: 0
    }
}

const getInitPLayerList = (): Participant[] => {
    const list: Participant[] = [];
    for (let i = 0; i < MINIMUM_PLAYER_SIZE; i++) {
        list.push(newPlayer(i + 1))
    }
    return list;
}


const PlayerForm = () => {
    const meleeContext = useMeleeContext();
    const [tournamentName, setTournamentName] = useState('');
    const [players, setPlayers] = useState(getInitPLayerList());
    const [groupMatches, setGroupMatches] = useState(4);

    const [isLoading, setIsLoading] = useState(false);

    const [formHasError, setFormHasError] = useState(false);
    const [shakeAnimation, setShakeAnimation] = useState(true);

    const[optionModalOpen, setOptionModalOpen] = useState(false);

    const navigate = useNavigate();

    const renderPlayerFields = () => {
        return (
            players.map((p) => {
                return (
                    <PlayerField
                        player={p}
                        removePlayer={removePlayer}
                        updatePlayerName={updatePlayerName}
                        autoFocus={players.length > MINIMUM_PLAYER_SIZE}
                        formHasError={formHasError}
                        setFormHasError={setFormHasError}
                    />
                )
            })
        )
    }

    const addPlayer = () => {
        players.push(newPlayer(players.length + 1))
        setPlayers([...players])
    }

    const removePlayer = (number: Number) => {
        if (players.length <= MINIMUM_PLAYER_SIZE) {
            const p = players.find((p) => p.Number === number);
            if (!p) throw new Error("Something went wrong when findizng player");
            p.Name = '';
            setPlayers([...players])
            return;
        }

        var filteredPlayers = players.filter((p) => p.Number !== number);
        filteredPlayers.forEach((p, index) => p.Number = index + 1);

        setPlayers([...filteredPlayers])
    }

    const updatePlayerName = (name: string, player: Participant): void => {
        player.Name = name;
        setPlayers([...players]);
    }

    const updateGroupMatches = (val: number) => {
        setGroupMatches(val);
    }

    const generateOnClick = () => {
        if (validateForm()) {
           
            startTour();
        } else {
            setShakeAnimation(!shakeAnimation); //Spiller shake animation
            setFormHasError(true);
        }
    }

    const validateForm = (): boolean => {
        let ok = true;
        players.forEach((p) => {
            if (p.Name.length < 1) {
                ok = false;
            }
        })
        return ok;
    }


    const startTour = () => {
        setIsLoading(true)

        var draftOptions : DraftOptions = meleeContext?.draftOptions ? meleeContext?.draftOptions : DefaultDraftOptions();

        const newTournament = GenerateTournament(players, groupMatches, StandardMatchesPrHeat(players), draftOptions);
  
        newTournament.Name = tournamentName;

        if (!newTournament) return;

        mixpanel.track("Tournament Generated",
        {
            "name" : tournamentName,
            "playerCount": players.length,
            "groupStageMatches" : newTournament.GroupStageGames.length,
            "matchesPrHeat" : newTournament.MatchesPrHeat,
            "localID" : newTournament.Id,
            "draftOptions" : newTournament.DraftOptions,
            "players" : newTournament.Players
        })
        

        localStorage.setItem(newTournament.Id!, JSON.stringify(newTournament));
        navigate('/tournament/' + newTournament.Id!.split("#")[1]);
    }



    return (
        <>
            <input
                className='big'
                value={tournamentName}
                onChange={(e) => setTournamentName(e.target.value)}
                placeholder={'Tournament Name'}
                maxLength={18}
            />

            <Divider />

            {renderPlayerFields()}

            <Button onClick={addPlayer} basic size='massive' className="melee" style={{marginBottom: 32}}><Icon name='add' />Add Player</Button>

            <p>
                Playing <b style={{textTransform: 'capitalize'}}>{meleeContext?.draftOptions.gameType}</b>, 
                with a <b>{meleeContext?.draftOptions.memeStageChance}%</b> chance of meme stages. {' '}
                <Button basic className='button melee basic icon' icon onClick={() => setOptionModalOpen(true)}><Icon name='cog'/>Edit</Button>
            </p>

            <GroupStageMatchesDropdown
                playerCount={players.length}
                groupMatches={groupMatches}
                updateGroupMatches={updateGroupMatches}
                totalGroupStageMatches={GetTotalGroupStageMatches(players.length, groupMatches)}
            />



            <TimeEstimator
                groupStageMatchCount={groupMatches}
                playerCount={players.length}
            />

            <Transition
                animation={'shake'}
                duration={700}
                visible={shakeAnimation}
            >
                <Button onClick={() => generateOnClick()} basic size='massive' className="melee" loading={isLoading} style={{marginTop: 32}}><Icon name='magic' />Generate</Button>
            </Transition>

            {meleeContext &&
                 <OptionsModal
                 open={optionModalOpen}
                 setOpen={setOptionModalOpen}
             />
            }
           

           
        </>
    )
}




export default PlayerForm;

